import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { Zap } from "lucide-react";
import qualityDashboard from "@/assets/analytics-quality-dashboard.png";
import { Badge } from "@/components/ui/badge";

const insights = [
  { icon: Zap, text: "Themen mit Optimierungsbedarf" },
  { icon: Zap, text: "Trainingspotenziale in der Wissensdatenbank" },
  { icon: Zap, text: "Schwachstellen in Prompt- oder Prozesslogik" },
];

const AnalyticsQualitaetSection = () => {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      ref={ref as React.RefObject<HTMLElement>}
      className={cn(
        "py-16 md:py-24 bg-secondary/20 transition-all duration-700 ease-out",
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      )}
    >
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Grafik links */}
          <div className="rounded-2xl overflow-hidden shadow-2xl border border-border">
            <img
              src={qualityDashboard}
              alt="Chathero AI Analytics – KI-Qualität: Automatisierungsquote, Übergaberate und Nutzerbewertungen"
              className="w-full h-auto object-contain"
              loading="lazy"
            />
          </div>

          {/* Text rechts */}
          <div>
            <Badge variant="outline" className="mb-4 text-sm font-semibold text-primary uppercase tracking-wider">KI-Qualität</Badge>
            <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4">
              KI-Qualität überwachen & optimieren
            </h2>
            <p className="text-lg text-muted-foreground mb-8">
              Automatisierung muss messbar sein. AI Analytics macht die Qualität Ihrer KI transparent – datenbasiert statt intuitiv.
            </p>

            <h3 className="text-base font-semibold text-foreground mb-4">Das erkennen Sie auf einen Blick:</h3>
            <div className="space-y-3">
              {insights.map((item, i) => (
                <div key={i} className="flex items-center gap-3 p-4 bg-card border border-border rounded-xl shadow-sm">
                  <item.icon className="w-5 h-5 text-chathero-mint shrink-0" />
                  <span className="text-muted-foreground">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AnalyticsQualitaetSection;
